module.exports = __webpack_public_path__ + "img/暂无评价.4c276429.png";